<template>
  <ckeditor
    @namespaceloaded="onNamespaceLoaded"
    :editor-url="editorUrl"
    :config="editorConfig"
    :value="value"
    @input="onInput"
  ></ckeditor>
  <!-- @change="onEditorChange"
    @blur="onEditorBlur" -->
</template>

<script>
import CKEditor from "ckeditor4-vue";
var toolbarGroups = [
  { name: "document", groups: ["mode", "document", "doctools"] },
  { name: "clipboard", groups: ["clipboard", "undo"] },
  { name: "editing", groups: ["find", "selection", "spellchecker", "editing"] },
  { name: "forms", groups: ["forms"] },
  { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
  {
    name: "paragraph",
    groups: ["list", "indent", "blocks", "align", "bidi", "paragraph"],
  },
  { name: "links", groups: ["links"] },
  { name: "insert", groups: ["insert"] },
  { name: "styles", groups: ["styles"] },
  { name: "colors", groups: ["colors"] },
  { name: "tools", groups: ["tools"] },
  { name: "others", groups: ["others"] },
  { name: "about", groups: ["about"] },
];

export default {
  name: "app",
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component,
  },
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      editorUrl: "https://cdn.ckeditor.com/4.22.1/standard/ckeditor.js",
      editorConfig: {
        toolbarGroups: toolbarGroups,
        removeButtons:
          "Smiley,SpecialChar,NewPage,Preview,Print,PageBreak,Blockquote,CreateDiv,Templates,Cut,Copy,Paste,PasteFromWord,PasteText,Find,Replace,SelectAll,Scayt,Form,Checkbox,TextField,Radio,Textarea,Select,Button,ImageButton,HiddenField,Subscript,Superscript,CopyFormatting,RemoveFormat,BidiLtr,BidiRtl,Language,Flash,Iframe,ShowBlocks,Maximize,About,Link,Unlink,Anchor",
        allowedContent: true,
        entities: false,
        htmlEncodeOutput: false,
        height: "322.5px",
        skin: "icy_orange,/js/ckeditor/skins/icy_orange/",
        extraPlugins: "codemirror",
        enterMode: 2, //  The Static Value of CKEDITOR.ENTER_BR
      },
    };
  },
  methods: {
    onNamespaceLoaded(CKEDITOR) {
      // Add external `placeholder` plugin which will be available for each
      // editor instance on the page.
      // enableExternal({ name: 'codemirror', path: '/js/ckeditor/plugins/codemirror/', file: 'plugin.js' });

      // console.log({ CKEDITOR, CKEditor });
      CKEDITOR.plugins.addExternal(
        "codemirror",
        "/js/ckeditor/plugins/codemirror/",
        "plugin.js"
      );

      const tags = {
        abbr: 0,
        acronym: 0,
        b: 0,
        bdi: 0,
        bdo: 0,
        big: 0,
        cite: 0,
        code: 0,
        del: 0,
        dfn: 0,
        em: 0,
        font: 0,
        i: 0,
        ins: 0,
        label: 0,
        kbd: 0,
        mark: 0,
        meter: 0,
        output: 0,
        q: 0,
        ruby: 0,
        s: 0,
        samp: 0,
        small: 0,
        span: 0,
        strike: 0,
        strong: 0,
        sub: 0,
        sup: 0,
        time: 0,
        tt: 0,
        u: 0,
        var: 0,
        script: 0,
      };

      CKEDITOR.dtd.$removeEmpty = tags;
      CKEDITOR.addCss(
        ".cke_table-faked-selection { background-color: #0076CB !important; }"
      );
    },
    onInput: function (value) {
      this.$emit("input", value);
    },
    onEditorChange: function (value) {
      // console.log({ onEditorChange: value });
    },
    onEditorBlur: function (value) {
      // console.log({ onEditorBlur: value });
    },
  },
};
</script>
<style>
.cke_notifications_area{
  z-index: -1000;
  visibility: hidden;
}
</style>